import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import axios, { setToken } from '../../../../my-axios';
import UserContext, { getToken } from '../../../../contexts/UserContext';
import ContentContext from '../../../../contexts/ContentContext';
import { Dropdown } from 'react-bootstrap';
import DataTable from '../../../controls/DataTable';
import DataTablePagination from '../../../controls/DataTablePagination';
import MsgBox from '../../../controls/MsgBox';
import SearchBox from '../../../controls/SearchBox';
import Spinner from '../../../controls/Spinner';
import { getErrorDesc, date2str, dateTime2str, getDate } from '../../../../utils/common';
import './styles.css';


const URL = "/appointment";
const titles = ["Time", "Name", "Dur.", "Doctor", "Status "];
const cols = ["date", "name", "duration", "doctor_name", "status"];

const statusList = [
  { code: 'ALL', name: 'ALL' },  // still needed for default & reset
  { code: 'CONFIRMED', name: 'CONFIRMED' },
  { code: 'UNCONFIRMED', name: 'UNCONFIRMED' }
];

const orderList = [
  { code: "ASC", name: "Ascending" },
  { code: "DESC", name: "Descending" }
]

const initState = {
  data: [],
  selectedRow: null,
  loading: false,
  msg: null
};

const initPaginationState = {
  total: 0,
  page: 1,
  size: 10
};

// const initFilterState = {
//   text: '',
//   date: getDate(),
//   selectedStatus: statusList[0]
// };


export default function AppointmentsList() {
  //console.log('PatientList')
  const navigate = useNavigate();
  const [search, setSearch] = useSearchParams();
  const userCtx = useContext(UserContext);
  const contentCtx = useContext(ContentContext);
  const [state, setState] = useState(initState);
  const [currentPage, setCurrentPage] = useState(initPaginationState);
  const [filter, setFilter] = useState({ selectedStatus: statusList[0], date: getDate(), text: search.get("text"), sortOrder: orderList[0] });

  useEffect(() => {
    contentCtx.updatePath([{ title: 'Appointments', link: '/appointments' }]);
    loadData(filter);
  }, [currentPage.page, currentPage.size, filter.selectedStatus, filter.text, filter.date, filter.sortOrder]);

  // useEffect(() => {
  //   var text = search.get("text");

  //   if (text) {
  //     console.log("Update filter in search: ", text);
  //     setFilter({ ...filter, text })
  //   }
  // }, [search])

  const loadData = (filterValues) => {
    setState({ ...state, loading: true, msg: null });
    axios.defaults.headers.common['Authorization'] = `Bearer ${userCtx.getToken()}`;
    axios.get(URL,
      {
        params: {
          page: currentPage.page,
          size: currentPage.size,
          status: filterValues.selectedStatus.code || 'ALL', // null will represent all
          text: filterValues.text,
          date: filterValues.date,
          order: filterValues.sortOrder.code
        },
      }).then((result) => {
        console.log("GetFromServer!!!", result.data);
        setState({
          ...state, data: formatData(result.data.data), loading: false, msg: null
        });
        setCurrentPage({ ...currentPage, total: result.data.total });
      }).catch((error) => {
        console.log('error:', error);
        if (error.response && error.response.status == 401) {
          navigate("/signout");
        }
        else {
          setState({
            ...state, data: [], loading: false, msg: getErrorDesc(error)
          });
        }
      });
  };

  const searchText = (text) => {
    console.log('searchText', text);
    setFilter({ ...filter, text });
  };

  const getStatus = (c) => {
    let result = statusList.find(status => status.code == c);
    if (result)
      return result;
    else {
      // console.log('Status not found!');
      return { code: 0, name: 'ALL' };
    }

  };

  const changeStatus = (selectedStatusCode) => {
    const selectedStatusItem = getStatus(selectedStatusCode);
    setFilter({
      ...filter,
      selectedStatus: selectedStatusItem
    });
  };

  const changeSortOrder = (selectedSortCode) => {
    const selectedSort = orderList.find(o => o.code === selectedSortCode);
    if (selectedSort) {
      setFilter({
        ...filter,
        sortOrder: selectedSort
      });
    }
  };


  const changeDate = (e) => {
    var tmp = e.target.value;
    console.log("changeDate: ", tmp);
    setFilter({
      ...filter,
      date: tmp
    });
  };


  const changeCurrentPage = (page) => {
    setCurrentPage({ ...currentPage, page });
  };
  const changePageSize = (size) => {
    setCurrentPage({ ...currentPage, size });
  };

  const formatData = (data) => {
    return data.map((r) => {
      return {
        ...r,
        //status: getStatus(r.status).name,
        name: `${r.firstname} ${r.surname}`,
        date: dateTime2str(r.date),
        date_create: date2str(r.date_create),
        date_change: date2str(r.date_change),
        note: r.note && r.note != 'null' ? r.note : '',
        duration: r.duration ? r.duration / 60 + ' min' : '10 min',
      };
    });
  };

  const showDetails = (el) => {
    navigate(`${URL}s/${el.id}`);
  };

  return (
    <>
      <div className="row mb-6">
        <div className="col-2 text-left" style={{ minWidth: "215px", marginRight: '18px' }}>
          <form className="form-inline">
            <div class="form-group">
              <label htmlFor="repStartFrom" className="font-weight-normal" style={{ marginRight: '5px' }}>Date from:</label>
              <input id="repStartFrom" type="date" className="form-control" value={filter.date} onChange={changeDate} />
            </div>
          </form>
        </div>
        <div className="col text-left" style={{ minWidth: "7em" }}>
          <SearchBox findText={searchText} text={filter.text} />
        </div>
        <div className="row text-right" style={{ marginLeft: "7rem" }}>
          <div className="form-group " style={{ marginRight: '0.5rem' }}>
            <Dropdown onSelect={changeSortOrder}>
              <Dropdown.Toggle
                id="sortOrderDropdown"
                title="Sort by appointment time: 'ASC' = nearest date, 'DESC' = latest date"
              >
                Time Order</Dropdown.Toggle>
              <Dropdown.Menu>
                {orderList.map((opt) => (
                  <Dropdown.Item
                    key={opt.code}
                    eventKey={opt.code}
                    active={filter.sortOrder.code === opt.code}
                  >
                    {opt.name}
                  </Dropdown.Item>
                ))}
                {filter.sortOrder.code !== "ASC" && (
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Item eventKey="ASC">Reset</Dropdown.Item>
                  </>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="form-group " style={{ marginRight: '1rem' }}>
            <Dropdown onSelect={changeStatus}>
              <Dropdown.Toggle id="basicItemCategory-basic">Status</Dropdown.Toggle>
              <Dropdown.Menu>
                {statusList
                  .filter((s) => s.code !== 'ALL')  // don't show 'ALL' visibly
                  .map((c) => (
                    <Dropdown.Item
                      key={c.code}
                      eventKey={c.code}
                      active={filter.selectedStatus.code === c.code}
                    >
                      {c.name}
                    </Dropdown.Item>
                  ))}
                {filter.selectedStatus.code !== "ALL" && (
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Item eventKey="ALL">Reset</Dropdown.Item>
                  </>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

      </div>

      <div className="row mb-6 p-10" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div className="col-12" style={{ flex: '1', overflow: 'hidden' }}>
          {/* Table container */}
          <div style={{ position: 'relative', width: '100%', overflowX: 'auto' }}>
            {/* Table contents */}
            <DataTable
              module={URL}
              id="id"
              list={{
                data: state.data,
                columns: cols,
                labels: titles,
              }}
              view={{
                label: 'Detail',
                colSize: 1,
                buttonSize: 12,
                buttons: [
                  {
                    label: 'More',
                    func: showDetails,
                  },
                ],
              }}
            />
          </div>
        </div>

        {/* Paginator, fixed below the table and sliding with the scroll bar */}
        <div style={{ width: '100%', paddingTop: '10px', textAlign: 'center', overflowX: 'auto', whiteSpace: 'nowrap' }}>
          <DataTablePagination
            page={currentPage.page}
            size={currentPage.size}
            total={currentPage.total}
            setPage={changeCurrentPage}
            setSize={changePageSize}
          />
        </div>

        <Spinner value={state.loading} />
        {state.msg !== null && <MsgBox value={{ type: 'error', title: '', msg: state.msg }} />}
      </div>

    </>
  );
}
